// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"c82da5a3","141":"82e072fc","216":"d0cf13f0","417":"48de0daa","472":"3834fed3","480":"3ccd052e","676":"7149870c","744":"73817573","786":"7149870c","794":"3834fed3","818":"c82da5a3","840":"3834fed3","879":"7149870c"}[chunkId] + ".chunk.css";
};